import withAuth from 'hocs/withAuth/withAuth';
import NotFoundSvg from 'icons/not-found.svg';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { Button } from 'components/Button';

import * as S from './styles';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <S.Grid data-testid="notfound">
      <S.StyledRow>
        <S.SectionContainer>
          <NotFoundSvg />
        </S.SectionContainer>
      </S.StyledRow>

      <S.StyledRow>
        <S.SectionContainer>
          <S.Description>
            <FormattedMessage id="PAGENOTFOUND.DESCRIPTION" />
          </S.Description>
        </S.SectionContainer>
      </S.StyledRow>

      <S.ButtonContainer>
        <Button
          data-testid="backToHomeButton"
          full
          onClick={() => navigate('/care-provider/info')}
        >
          <FormattedMessage id="PAGENOTFOUND.GOBACK" />
        </Button>
      </S.ButtonContainer>
    </S.Grid>
  );
};

export default withAuth(NotFound);
